export default "__VITE_ASSET__DirgG4o7__"